import { activityNames, activityTypes } from '../../../utils/constants/misc'
import {
  dateOperators,
  equalityOperators,
  multiselectOperators,
  textOperators
} from '../../../utils/constants/operators'

export const productColumns = [
  {
    name: 'reference',
    label: 'Référence',
    isFilter: true,
    operators: textOperators
  },
  {
    name: 'name',
    label: 'Nom',
    isFilter: true,
    operators: textOperators
  },
  {
    name: 'createdDateTime',
    label: 'Date Création',
    isFilter: true,
    inputType: 'datetime-local',
    type: 'date',
    format: 'DD/MM/YYYY HH:mm:ss',
    operators: dateOperators
  },
  {
    name: 'createdBy',
    label: 'Créé Par',
    isFilter: true,
    operators: textOperators
  },
  {
    name: 'lastModDateTime',
    label: 'Date Modification',
    isFilter: true,
    inputType: 'datetime-local',
    type: 'date',
    format: 'DD/MM/YYYY HH:mm:ss',
    operators: dateOperators
  },
  {
    name: 'lastModBy',
    label: 'Modifié Par',
    isFilter: true,
    operators: textOperators
  }
]

export const getProductFields = () => [
  [
    {
      name: 'description',
      label: 'Description',
      required: true,
      type: 'text',
      fullWidth: true,
      validation: [
        {
          rule: 'req',
          error: 'Description obligatoire'
        }
      ]
    }
  ],
  [
    {
      name: 'cost',
      label: 'Coût',
      required: true,
      fullWidth: true,
      type: 'currency',
      min: 0,
      validation: [
        {
          rule: 'req',
          error: 'Coût obligatoire'
        }
      ]
    }
  ]
]
